var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckoutStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.8311,
    r: 33.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3517_65125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7417 44.1668L29.6478 42.3353C29.5262 42.2809 29.3934 42.2561 29.2604 42.2629C29.1274 42.2697 28.9979 42.3078 28.8824 42.3741L27.0694 43.4166C26.9437 43.4888 26.8386 43.5921 26.7643 43.7166C26.69 43.8411 26.649 43.9827 26.6453 44.1276C26.6416 44.2726 26.6752 44.416 26.743 44.5442C26.8107 44.6724 26.9104 44.781 27.0322 44.8595L33.2112 48.847C33.3238 48.9196 33.4521 48.9644 33.5855 48.9776C33.7189 48.9908 33.8535 48.9721 33.9782 48.9231L41.2436 46.0507L38.792 52.4172C38.7295 52.5778 38.7177 52.7536 38.7581 52.9211C38.7984 53.0886 38.889 53.2397 39.0177 53.3542C39.1464 53.4688 39.3071 53.5412 39.4781 53.5619C39.6492 53.5825 39.8224 53.5504 39.9747 53.4698L41.6085 52.625C41.7563 52.5493 41.8786 52.4318 41.96 52.2871L46.5219 43.9607L52.3545 41.384C52.8826 41.1624 53.301 40.7401 53.5178 40.21C53.7345 39.6799 53.7318 39.0854 53.5102 38.5573C53.2886 38.0292 52.8663 37.6107 52.3362 37.394C51.806 37.1773 51.2115 37.18 50.6834 37.4016L33.7417 44.1668Z",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4705 39.8836L38.0044 35.8286C37.8791 35.7489 37.7351 35.7038 37.5867 35.6975C37.4384 35.6913 37.2911 35.7243 37.1596 35.7931L35.426 36.6886C35.2951 36.7559 35.1841 36.8564 35.1039 36.9799C35.0238 37.1034 34.9773 37.2457 34.9691 37.3927C34.9609 37.5398 34.9913 37.6864 35.0572 37.818C35.1231 37.9497 35.2223 38.0618 35.3449 38.1433L40.3952 41.5023",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0518 40.7371C22.7017 40.2597 20.5353 39.1252 18.8043 37.4656C17.0733 35.8059 15.8488 33.6891 15.273 31.3611C14.6972 29.0331 14.7938 26.5896 15.5516 24.3144C16.3094 22.0391 17.6972 20.0256 19.5539 18.5078C21.4105 16.9899 23.6597 16.0301 26.0402 15.7397C28.4206 15.4494 30.8346 15.8404 33.0017 16.8675C35.1687 17.8946 36.9998 19.5155 38.2823 21.5418C39.5647 23.5682 40.2459 25.9169 40.2465 28.315",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6808 38.218L20.8162 32.5392H22.0327C22.2894 32.5391 22.5427 32.4806 22.7733 32.368C23.004 32.2555 23.2059 32.0919 23.3639 31.8896C23.5219 31.6873 23.6317 31.4517 23.685 31.2007C23.7383 30.9496 23.7338 30.6897 23.6717 30.4407L22.8269 27.0615C22.7357 26.6958 22.5248 26.3711 22.2278 26.139C21.9309 25.907 21.5648 25.7809 21.1879 25.7808H15.1577",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6956 20.7119H33.1184C32.7415 20.712 32.3755 20.8381 32.0785 21.0702C31.7816 21.3023 31.5707 21.627 31.4795 21.9926L30.6347 25.3719C30.5726 25.6209 30.568 25.8808 30.6213 26.1318C30.6747 26.3829 30.7845 26.6185 30.9425 26.8207C31.1004 27.023 31.3024 27.1866 31.5331 27.2992C31.7637 27.4118 32.017 27.4703 32.2736 27.4704H34.0528L34.9432 32.818",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3517_65125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.5507,
    height: 40.5507,
    fill: "white",
    transform: "translate(14 14.3315)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckoutStart);
export default __webpack_public_path__ + "static/media/Icon_checkout_start.26678051.svg";
export { ForwardRef as ReactComponent };